import { render } from "./FilterColorComponent.vue?vue&type=template&id=e3ffddb8&ts=true"
import script from "./FilterColorComponent.vue?vue&type=script&lang=ts"
export * from "./FilterColorComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__